import connectFactory from './connectFactory';
import createComponentFactory from './createComponentFactory';
import FelaComponentFactory from './FelaComponentFactory';
import FelaThemeFactory from './FelaThemeFactory';
import ProviderFactory from './ProviderFactory';
import ThemeProviderFactory from './ThemeProviderFactory';
import withThemeFactory from './withThemeFactory';
import createTheme from './createTheme';
import feFactory from './feFactory';
import { THEME_CHANNEL } from './themeChannel';

export { connectFactory, createComponentFactory, FelaComponentFactory, FelaThemeFactory, ProviderFactory, ThemeProviderFactory, withThemeFactory, createTheme, feFactory, THEME_CHANNEL };


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/index.js
// module id = 8
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38